export const english = {
  // Processing Result States
  test_completed_processing_result_states: 'Test completed!',
  video_upload_in_progress_processing_result_states: 'Your video is still being uploaded, please wait...',
  test_success_message_processing_result_states:
    'Great job! You have successfully completed the test.',
  test_completed_processing_result_description:
    'Generating your score... This may take a while',
  preparing_report_processing_result_states: 'I am preparing your report...',

  // Welcome States
  welcome_message_setup_states_welcome: 'Welcome',
  julia_introduction_setup_states_welcome:
    'I am Julia and I will be helping you with the',
  fluency_test_setup_states_welcome: 'Fluency Test.',
  setup_message_setup_states_welcome:
    'Before we start, we need to do a quick setup. Shall we?',
  next_button_setup_states_welcome: 'Next',

  // Listening Test States
  check_sound_setup_states_listening_test: "Let's check your sound!",
  audio_test_message_setup_states_listening_test:
    'I will send you an audio and see if you can hear me.',
  listening_button_setup_states_listening_test: 'I can hear',
  not_listening_button_setup_states_listening_test: "I can't hear",

  // Listening Test Error Container
  hmm_listening_test_error: 'Hmm...',
  not_hearing_listening_test_error: 'Not hearing me?',
  troubleshoot_message_listening_test_error:
    'Check if your headphones have low volume or are disconnected. If the problem persists, speak with the responsible teacher.',
  try_again_listening_test_error: 'Try again',

  // Timer Tip States
  last_thing_setup_states_timer_tip: 'Oh! One last thing...',
  timer_message_part1_setup_states_timer_tip:
    'Keep an eye on the clock! Speak for at least',
  twenty_seconds_setup_states_timer_tip: '20 seconds',
  timer_message_part2_setup_states_timer_tip:
    'in each audio. The more you speak, the better your result will be.',
  start_warmup_setup_states_timer_tip: 'Start warmup',

  // Recording Test Error States
  hmm_recording_test_error: 'Hmm...',
  microphone_not_good_recording_test_error:
    "Your microphone doesn't seem good.",
  audio_quality_recording_test_error: 'Audio quality:',
  microphone_settings_message_recording_test_error:
    'Check your microphone settings or speak with the responsible teacher.',
  try_again_recording_test_error: 'Try again',

  // Recording User Audio States
  great_recording_user_audio: 'Great!',
  almost_there_recording_user_audio: "We're almost there",
  record_audio_instruction_recording_user_audio:
    'Now record the audio reading the phrase below:',
  record_audio_button_recording_user_audio: 'Record Audio',

  // Video setup
  video_check_title_video_test: 'We are close!',
  video_check_subtitle_video_test: 'This is the last settings',
  video_check_instruction_video_test:
    "In this test, we'll record your video and verify that everything is working correctly with your camera.",
  enable_camera_button_video_test: 'Allow access',
  next_button_video_test_done: 'Continue',
  camera_disabled_video_test_error: 'Camera is disabled.',
  camera_enable_instructions_video_test_error:
    'In your browser\'s address bar, click the icon next to the website address, select "Allow camera," and reload the page.',
  reload_button_video_test_error: 'Reload',
  video_check_terms:
    'By continuing, you agree that this video will be recorded and stored.',

  // Word Usage Chart Components
  advanced_words_app_resultado_components_word_usage_chart: 'advanced words',

  // Export Page
  complete_report_app_resultado_export_page: 'Complete report:',
  page_number_app_resultado_export_page: 'Page {0}/5',
  performed_by_app_resultado_export_page: 'Performed by: {0}',
  performed_on_app_resultado_export_page: 'Performed on: {0}',
  overall_result_app_resultado_export_page: 'Overall Result',
  fluency_analysis_app_resultado_export_page: 'Fluency analysis',
  speaking_time_app_resultado_export_page: 'Speaking time',
  seconds_label_app_resultado_export_page: 'Seconds',
  pause_count_app_resultado_export_page: 'Number of pauses',
  pauses_label_app_resultado_export_page: 'Pauses',
  vocabulary_analysis_app_resultado_export_page: 'Vocabulary analysis',
  pronunciation_analysis_app_resultado_export_page: 'Pronunciation analysis',
  grammar_analysis_app_resultado_export_page: 'Grammar analysis',
  coherence_analysis_app_resultado_export_page: 'Coherence analysis',

  //Category score
  title_category_score: 'Score by Category',
  label_pronunciation_category_score: 'Pronunciation',
  label_fluency_category_score: 'Fluency',
  label_grammar_category_score: 'Grammar',
  label_coherence_category_score: 'Coherence',
  label_vocabulary_category_score: 'Vocabulary',

  //Recording audio
  twenty_seconds_recording_audio:
    'You spoke for {0} seconds. Try speaking more than 20 seconds to get a better result.',

  //User Message
  loading_user_message: 'Loading',

  //Microphone permission
  click_microphone_permission: 'Click',
  allow_mic_microphone_permission: 'Allow Microphone',
  message_one_microphone_permission:
    'We will need your microphone to be enabled, just click the button',
  message_two_microphone_permission: 'Allow Microphone Access',
  message_three_microphone_permission: 'and then click the button',
  message_four_microphone_permission: 'Allow',
  message_five_microphone_permission: 'in your browser.',

  // Export Page
  grammar_vocabulary_analysis_app_resultado_export_page:
    'Grammar and vocabulary analysis',
  conversation_analysis_app_resultado_export_page: 'Conversation analysis',
  advanced_words_usage_app_resultado_export_page:
    'Usage of advanced level words',
  cefr_reference_app_resultado_export_page:
    'Common European Framework of Reference for Languages',
  total_pause_duration_app_resultado_export_page: 'Total pause duration',
  longest_phrase_without_hesitation_app_resultado_export_page:
    'Size of longest phrase without hesitation',

  site_demonstration_contact_app_resultado_page: 'Reach us out',
  demonstration_result_warning:
    'You have completed a shorter, demo test. The results may not reflect your actual fluency. For the full experience, please contact us.',

  // Resultado Page
  performed_by_app_resultado_page: 'Performed by: {0}',
  performed_on_app_resultado_page: 'Performed on: {0}',
  overall_result_app_resultado_page: 'Overall Result',
  oral_expression_level_app_resultado_page: 'Oral expression level',
  fluency_level_app_resultado_page: 'English fluency level',
  conversation_analysis_app_resultado_page: 'Conversation analysis',
  fluency_analysis_app_resultado_page: 'Fluency analysis',
  conversation_analysis_grammar_errors_app_resultado_page: 'Grammar errors',
  conversation_analysis_words_app_resultado_page: 'Words',
  conversation_analysis_unique_words_app_resultado_page: 'Unique words',
  grammar_vocabulary_analysis_app_resultado_page:
    'Grammar and vocabulary analysis',
  terms_used_section_app_resultado_page: 'Terms used in main grammars',
  advanced_words_usage_app_resultado_page: 'Usage of advanced level words',
  conversation_recording_app_resultado_page: 'Conversation recording',
  view_errors_only_app_resultado_page: 'View errors only',
  view_full_conversation_app_resultado_page: 'View full conversation',
  hidden_audio_single_app_resultado_page: 'hidden audio',
  hidden_audio_plural_app_resultado_page: 'hidden audios',

  // Onboarding Modal
  step_number_onboarding_modal: 'Step {0}',
  verify_data_onboarding_modal: 'Verify data',
  know_you_better_onboarding_modal: 'We want to know you better',
  data_verification_onboarding_modal: 'Data verification',
  about_student_onboarding_modal: 'About the student',
  before_start_verification_onboarding_modal:
    'Before starting, we need to verify some data',
  student_data_onboarding_modal: 'Student data',
  student_name_onboarding_modal: 'Student name',
  birth_date_onboarding_modal: 'Birth Date',
  incorrect_data_onboarding_modal: 'Incorrect data',
  confirm_data_onboarding_modal: 'Confirm Data',
  questionnaire_completed_onboarding_modal: 'Questionnaire completed!',
  thanks_information_onboarding_modal:
    'Thank you for the information. Shall we start the test?',
  complete_and_go_to_test_onboarding_modal: 'Complete and go to test',
  sending_information_onboarding_modal: 'Sending information...',
  incorrect_registration_onboarding_modal: 'Incorrect registration',
  cannot_continue_test_onboarding_modal:
    'It will not be possible to continue with the test at the moment. Speak with the responsible teacher.',
  understood_onboarding_modal: 'Understood',

  // Analysis Card
  score_detail_analysis_card: 'Score details',

  // Fluency Card
  speech_speed_fluency_card: 'Speech speed',
  speech_speed_description_fluency_card:
    'Speech speed including pauses and silence time',
  articulation_speed_fluency_card: 'Articulation speed',
  articulation_speed_description_fluency_card:
    'Speech speed disregarding silence time and pauses.',

  // Test Start Message
  test_start_test_start_message: 'Test start',
  great_job_test_start_message: 'Great job!',
  now_fluency_test_test_start_message: "Now let's go to the fluency test.",
  test_start_complete_message_test_start_message_well_done: 'Great job!',
  test_start_complete_message_test_start_message_start_over:
    "Now let's go to the",
  test_start_complete_message_test_start_message_fluency_test: 'fluency test.',
  remember_speak_maximum_test_start_message:
    'Remember to speak as much as you can! This is the moment to shine!',

  // Microphone Permission Error
  microphone_disabled_microphone_permission_error: 'Microphone is Disabled!',
  step_one_microphone_permission_error:
    "1. In your browser's address bar, click the icon next to the site address;",
  step_two_microphone_permission_error: '2. Then, select Allow microphone;',
  step_three_microphone_permission_error: '3. Reload this page to try again.',
  reload_microphone_permission_error: 'Reload',

  // Conversation Analysis Labels
  grammar_errors_conversation_analysis: 'Grammar errors',
  words_conversation_analysis: 'Words',
  unique_words_conversation_analysis: 'Unique words',
  sentences_conversation_analysis: 'Sentences',
  average_words_per_sentence_conversation_analysis:
    'Average words per sentence',
  average_unique_words_per_sentence_conversation_analysis:
    'Average unique words per sentence',
  total_syllables_conversation_analysis: 'Total syllables',
  words_with_two_or_more_syllables_conversation_analysis:
    'Words with more than two syllables',
  long_pauses_plural_label_conversation_analysis: 'Long pauses',
  long_pause_label_conversation_analysis: 'Long pause',
  errors_plural_label_conversation_analysis: 'Errors',
  error_label_conversation_analysis: 'Error',

  // Silence Time Chart
  speaking_time_silence_time_chart: 'Speaking time',

  // Login State
  app_name_login: 'FluencyFlow',
  simple_engaging_fluency_test_login: 'Simple and engaging fluency test.',
  we_make_it_easier_login: 'We make it easier.',
  access_code_label_login_form: 'Access code',
  unauthorized_error_login_form: 'Unauthorized access code.',
  test_in_progress_error_login_form: 'The test is in progress or completed.',

  // Terms Used Table
  grammar_terms_used_table: 'Grammar',
  quantity_terms_used_table: 'Qty. Terms',
  terms_terms_used_table: 'Terms',

  // Analysis Card
  example_label_analysis_card: 'Example:',
  fluency_title_analysis_card: 'Fluency',
  fluency_title_mobile_analysis_card: 'Fluency',

  // Descriptive Feedback
  descriptive_feedback_title: 'Descriptive feedback',

  // Speaking Metrics
  speaking_time_speaking_metrics: 'Speaking time',
  seconds_label_speaking_metrics: 'Seconds',
  pause_count_speaking_metrics: 'Number of pauses',
  pauses_label_speaking_metrics: 'Pauses',
  pauses_ideal_label_speaking_metrics: 'Ideal',
  total_pause_duration_speaking_metrics: 'Total pause duration',
  longest_phrase_without_hesitation_speaking_metrics:
    'Size of longest phrase without hesitation',
  until_speaking_metrics: 'until',
  more_speaking_metrics: 'more',

  // Analysis Types
  grammar_analysis_type: 'Grammar',
  vocabulary_analysis_type: 'Vocabulary',
  coherence_analysis_type: 'Coherence',

  // Ready to Icebreak State
  lets_warm_up_ready_to_icebreak: "Let's",
  warm_up_ready_to_icebreak: 'Warm up!',
  ready_to_start_warmup_ready_to_icebreak: 'Now we are ready to start the',
  warmup_ready_to_icebreak: 'warmup.',
  warmup_description_ready_to_icebreak:
    'It will be based on a conversation. I will ask you questions and you answer me.',
  next_button_ready_to_icebreak: 'Next',

  // Icebreak Start Message
  warmup_start_icebreak_start_message: 'Warmup start',

  // Recording Test Done State
  wonderful_recording_test_done: 'Wonderful!',
  hearing_you_recording_test_done: 'I can hear you',
  settings_completed_recording_test_done:
    'Settings completed! Everything is working so we can move to the next step.',
  next_button_recording_test_done: 'Next',

  // Fluency Chart
  slow_fluency_chart: 'Slow',
  fast_fluency_chart: 'Fast',

  // Analysis Card Metrics Details
  // Grammar Metrics
  length_analysis_card: 'Length',
  length_title_analysis_card: 'About Length',
  length_about_analysis_card:
    'This metric provides information about how long the recognized message or response is. The way sentences are connected influences the score.',
  length_bad_example_analysis_card:
    'The sun shines brightly. Flowers are beautiful.',
  length_good_example_analysis_card:
    'The sun shines brightly and colorful flowers are beautiful.',

  grammatical_accuracy_analysis_card: 'Grammatical Accuracy',
  grammatical_accuracy_title_analysis_card: 'About Grammatical Accuracy',
  grammatical_accuracy_about_analysis_card:
    'This metric analyzes the correctness and accuracy of grammar usage, including aspects such as correct use of verb tenses, verb agreement and proper word order. The score is also influenced by the proper connection between words and sentences.',
  grammatical_accuracy_bad_example_analysis_card:
    'Hi, my name are Anna. I have 20 years old.',
  grammatical_accuracy_good_example_analysis_card:
    "Hi, my name is Anna and I'm 20 years old.",

  grammatical_range_analysis_card: 'Grammatical Range',
  grammatical_range_title_analysis_card: 'About Grammatical Range',
  grammatical_range_about_analysis_card:
    'This metric evaluates the level of diversity in syntactic structures present in the recognized message or response, considering factors such as variety of verbs, adjectives, adverbial modifiers, among others.',
  grammatical_range_bad_example_analysis_card:
    "I'm Anna. I'm Brazilian. I'm 20 years old.",
  grammatical_range_good_example_analysis_card:
    "My name is Anna. I'm a 20-year-old girl from Brazil.",

  // Vocabulary Metrics
  lexical_range_analysis_card: 'Lexical Range',
  lexical_range_title_analysis_card: 'About Lexical Range',
  lexical_range_about_analysis_card:
    'This metric evaluates the variety of words used and the degree of use of advanced and less common vocabulary. It has to do with the careful choice of appropriate words, which offer detail and clarity in message transmission.',
  lexical_range_bad_example_analysis_card: 'It was a good day. I saw birds.',
  lexical_range_good_example_analysis_card:
    "The weather was just perfect and I couldn't help but notice a variety of birds...",

  collocation_commonality_analysis_card: 'Collocation Commonality',
  collocation_commonality_title_analysis_card: 'About Collocation Commonality',
  collocation_commonality_about_analysis_card:
    'This metric evaluates the use of word combinations, such as collocations, prepositional phrases and dependent prepositions. The goal is to evaluate how much the speech aligns with colloquial and natural linguistic patterns.',
  collocation_commonality_bad_example_analysis_card:
    'I have a brother. I like him.',
  collocation_commonality_good_example_analysis_card:
    'I have a brother and we get along really well.',

  natural_phrases_analysis_card: 'Natural Phrases',
  natural_phrases_title_analysis_card: 'About Natural Phrases',
  natural_phrases_about_analysis_card:
    'This metric evaluates how natural, colloquial and culturally appropriate the language used is.',
  natural_phrases_bad_example_analysis_card:
    "I am an engineer. I'm responsible for...",
  natural_phrases_good_example_analysis_card:
    "In my role as an engineer I'm in charge of...",

  // Coherence Metrics
  content_words_analysis_card: 'Content Words',
  content_words_title_analysis_card: 'About Content Words',
  content_words_about_analysis_card:
    'This metric evaluates the proportion of unique words or content words, which are those that contribute directly to meaning or content, as opposed to words that primarily perform grammatical or linking functions.',
  content_words_bad_example_analysis_card: ' I am a teacher and I work a lot',
  content_words_good_example_analysis_card:
    'I am a passionate and experienced teacher who works hard in a renowned school',

  connectors_analysis_card: 'Connectors',
  connectors_title_analysis_card: 'About Connectors',
  connectors_about_analysis_card:
    'These are words or expressions that establish logical relationships and cohesion between parts of a speech or text. These connectives help connect ideas, indicate contrast, addition, conclusion, negation, among other relationships.',
  connectors_bad_example_analysis_card:
    'Yesterday was a nice day. We went to the beach. The sun was hot.',
  connectors_good_example_analysis_card:
    'Yesterday was a nice day because the sun was hot. So, we went to the beach.',

  pronoun_density_analysis_card: 'Pronoun Density',
  pronoun_density_title_analysis_card: 'About Pronoun Density',
  pronoun_density_about_analysis_card:
    'This metric evaluates the degree of pronoun use in the response. A high pronoun density can indicate more concise and dynamic speech since the use of pronouns avoids excessive repetition of nouns and contributes to the fluency and clarity of the text.',
  pronoun_density_bad_example_analysis_card:
    "It's my dad's birthday. I bought a gift for my father.",
  pronoun_density_good_example_analysis_card:
    "It's my father's birthday so I bought him a gift.",

  adverb_diversity_analysis_card: 'Adverb Diversity',
  adverb_diversity_title_analysis_card: 'About Adverb Diversity',
  adverb_diversity_about_analysis_card:
    'This metric refers to the variety of adverbs used in the response. A high adverb density can indicate more descriptive and detailed language.',
  adverb_diversity_bad_example_analysis_card: 'I bought a gift for my father.',
  adverb_diversity_good_example_analysis_card:
    "Yesterday, I suddenly remembered it was my father's birthday so I quickly bought him a gift.",

  verb_diversity_analysis_card: 'Verb Diversity',
  verb_diversity_title_analysis_card: 'About Verb Diversity',
  verb_diversity_about_analysis_card:
    'This metric evaluates the degree and variety of verbs in the response. Analyzing verb density in a text can provide insights about the dynamism, action and fluency of speech.',
  verb_diversity_bad_example_analysis_card:
    'I like pasta. I like food. I like chocolate.',
  verb_diversity_good_example_analysis_card:
    'I like pasta. I love food. I enjoy hanging out with friends.',

  // CEFR Levels
  cefr_a1_title: 'Beginner',
  cefr_a1_description:
    'Can understand and use familiar everyday expressions and simple phrases related to concrete situations. Is able to introduce themselves, answer basic questions about personal information and interact in a limited way, as long as the interlocutor speaks slowly, clearly and is willing to help. Deals with vocabulary restricted to immediate needs.',

  cefr_a2_title: 'Elementary',
  cefr_a2_description:
    'Can communicate in simple and routine tasks that require direct exchange of information about familiar subjects. Is able to describe with chained phrases aspects of their daily life, such as family, work or school environment, preferences and basic needs. Shows greater autonomy in predictable interactions, although still with limited vocabulary and simple constructions.',

  cefr_b1_title: 'Intermediate',
  cefr_b1_description:
    'Can understand the main points of clear information in standard language about familiar topics, such as work, leisure or school. Is able to deal with most situations that may arise when traveling to English-speaking countries and can produce simple, connected and coherent texts about known subjects. Can express opinions, describe experiences and briefly justify plans and decisions.',

  cefr_b2_title: 'Upper Intermediate',
  cefr_b2_description:
    'Can understand main ideas of more complex texts, including technical discussions in their area of expertise. Interacts with sufficient fluency and spontaneity to maintain a natural conversation with native speakers. Can argue clearly, develop points of view, present advantages and disadvantages and produce well-structured and detailed texts on a wide variety of topics.',

  cefr_c1_title: 'Advanced',
  cefr_c1_description:
    'Can understand a wide range of long and demanding texts, identifying implicit meanings, figurative use and complex structures. Expresses themselves fluently, spontaneously and effectively, with a high degree of lexical precision and grammatical mastery. Is able to adapt their language to context and interlocutor, showing communicative flexibility in complex academic, professional and social situations.',

  cefr_c2_title: 'Proficiency',
  cefr_c2_description:
    'Can understand with ease practically everything they hear or read, including abstract, technical or literary texts. Is able to summarize information from various sources, reconstruct arguments and present content coherently. Expresses themselves with precision, naturalness and spontaneity, even in highly complex situations or with strong emotional load, demonstrating full mastery of the language.',

  // New keys for buttons
  incorrect_data_button_setup_states_welcome_onboarding_modal: 'Incorrect data',
  confirm_data_button_setup_states_welcome_onboarding_modal: 'Confirm Data',
  complete_and_go_to_test_button_setup_states_welcome_onboarding_modal:
    'Complete and go to test',
  understood_button_setup_states_welcome_onboarding_modal: 'Understood',
  reload_button_setup_states_microphone_permission_error: 'Reload',
  allow_microphone_access_button_setup_states_microphone_permission:
    'Allow microphone access',
  access_button_login_form: 'Access',
  send_button_recording_audio: 'Send',
  got_it_button_recording_audio: 'GOT IT',
  repeat_slower_button_testing_didnt_understand: 'Repeat slower',
  next_question_button_testing_didnt_understand: 'Next question',
  didnt_understand_icebreak_testing_didnt_understand: "I didn't understand",
  didnt_understand_test_testing_didnt_understand: "Didn't understand",
  close_modal_button: 'Close',
  confirm_button_setup_about_student_form: 'Confirm Data',
  confirm_topic_button_topic_selector: 'Confirm',

  steps_introduction: 'Introduction',
  steps_warmup: 'Warmup',
  steps_test: 'Test',
  steps_result: 'Result',

  title_message_topic_selector: 'Select to topics:',

  result_nav_bar_result: 'Result',
  result_nav_bar_fluency_analysis: 'Fluency Analysis',
  result_nav_bar_grammar_analysis: 'Grammatical Analysis',
  result_nav_bar_conversation_recording: 'Conversation Recording',

  // Demo Access Expired
  title_demo_access_expired: 'Your access has expired',
  message_demo_access_expired:
    'We could not resume your test. Please contact the test administrator to get a new access link.'
}
